import React, { FunctionComponent } from 'react'
import { ImageSourcePropType } from 'react-native'

import styled from 'styled-components/native'

import medsImage from '../../assets/meds.png'
import { tID } from '../../utils/utils'
import { Image } from '../image/Image'

const ImageContainer = styled(Image)<{ size: string }>(({ size }) => ({
  width: size,
  height: size,
}))

/**
 * Illustration to show on the treatment card
 */
export const Meds: FunctionComponent<MedsProps> = ({ size = 124 }) => {
  const sizeInPixels = `${size}px`
  return (
    <ImageContainer
      size={sizeInPixels}
      testID={`${tID('MedsIllustration')}`}
      source={medsImage as ImageSourcePropType}
    />
  )
}

type MedsProps = {
  size?: number
}
